import { IRoute } from 'model/interfaces/IRoute';
import { RouteStatusEnum } from 'model/enums/RouteStatusEnum';

export const isUnderModification = (routes: Array<IRoute>) =>
	routes.some(route => route?.status === RouteStatusEnum.UNDER_MODIFICATION);